import { useFormContext, useWatch } from 'react-hook-form';
import { ITap2MineReferralForm } from 'features/tap2mine-referral/types';

export const useTap2MineReferralCode = () => {
  const {
    formState: { isValid, isValidating },
  } = useFormContext<ITap2MineReferralForm>();

  const code = useWatch<ITap2MineReferralForm>({ name: 'refCode' });

  return {
    code,
    isValidCode: !code || (isValid && !isValidating),
    isValidating,
  };
};
